/** Canonical annotation face used by both the browser preview and Pillow bake. */
export const ANNOTATION_FONT_FAMILY = 'Dreamwrite Annotation'
export const ANNOTATION_FONT_WEIGHT = '700'

const FONT_LOAD_SPEC = `${ANNOTATION_FONT_WEIGHT} 16px "${ANNOTATION_FONT_FAMILY}"`
const COVERAGE_PROBE = 'Dreamwrite 中文 한국어'

let fontLoadPromise: Promise<void> | null = null

/**
 * Wait until the vendored CJK face is ready before measuring or drawing text.
 * A silent fallback recreates the preview/save mismatch this font is meant to
 * remove, so an unavailable Font Loading API or failed face is an explicit
 * error rather than permission to use a system font.
 */
export function ensureAnnotationFontLoaded(): Promise<void> {
  if (fontLoadPromise) return fontLoadPromise

  fontLoadPromise = (async () => {
    if (typeof document === 'undefined' || !document.fonts) {
      throw new Error('Browser Font Loading API is unavailable for annotation text.')
    }
    await document.fonts.load(FONT_LOAD_SPEC, COVERAGE_PROBE)
    if (!document.fonts.check(FONT_LOAD_SPEC, COVERAGE_PROBE)) {
      throw new Error(
        `Annotation font "${ANNOTATION_FONT_FAMILY}" failed to load; text preview is disabled.`,
      )
    }
  })().catch((error) => {
    fontLoadPromise = null
    throw error
  })

  return fontLoadPromise
}

/** Test-only reset for suites that replace `document.fonts` between cases. */
export function resetAnnotationFontForTest(): void {
  fontLoadPromise = null
}
